import { ApolloLink, Observable } from '@apollo/client';

export class LoaderLink extends ApolloLink {
  constructor(loaderControls) {
    super();

    this.loaderControls = loaderControls;
  }

  request(operation, forward) {
    const { incrementLoaderCounter, decrementLoaderCounter } = this.loaderControls;
    const context = operation.getContext();

    const isBackgroundLoading = context.backgroundLoading;
    const ignoreCache = context.ignoreCache;
    const isQuery = operation.query.definitions.some(def => def.operation === 'query');

    const isBackgroundQuery =
      isQuery && isBackgroundLoading && (ignoreCache || context.cache.readQuery(operation));

    if (isBackgroundQuery) {
      return forward(operation);
    }

    const isBackgroundMutation = !isQuery && isBackgroundLoading;
    if (isBackgroundMutation) {
      return forward(operation);
    }

    incrementLoaderCounter();

    return new Observable(observer => {
      forward(operation).subscribe({
        next: observer.next.bind(observer),
        error: error => {
          decrementLoaderCounter();
          observer.error(error);
        },
        complete: () => {
          decrementLoaderCounter();
          observer.complete();
        }
      });
    });
  }
}
